import type { FC, ReactNode } from 'react'

import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingProps {
    label: string
    className?: string
    size?: 'sm' | 'md'
}

export const StarRating: FC<StarRatingProps> = ({ label, className, size = 'md' }): ReactNode => {
    return (
        <span role='img' aria-label={label} className={cn('inline-flex items-center gap-0.5 text-primary', className)}>
            {Array.from({ length: 5 }, (_, index) => (
                <Star
                    key={index}
                    aria-hidden='true'
                    className={size === 'sm' ? 'size-3.5' : 'size-4'}
                    fill='currentColor'
                    strokeWidth={0}
                />
            ))}
        </span>
    )
}
